module.exports = __webpack_public_path__ + "static/media/giphy-1.11e70b9e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-1.gif
// module id = 172
// module chunks = 0